import styled from 'styled-components';

import bubbles from '../../images/bubles.png';

interface Props {
  className?: string;
  imgPath?: string;
}

const CardPanel = ({ className = '', imgPath = '' }: Props) => (
  <div className={className}>
    <div className="card-panel__left">
      <h3>Coming soon</h3>
    </div>

    <div className="card-panel__right" style={{ backgroundImage: `url(${imgPath})` }} />
  </div>
);

const StyledCardPanel = styled(CardPanel)`
  display: flex;
  gap: 16px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.neutralBorder};
  background-color: ${({ theme }) => theme.neutralBackgroundBase};
  flex-grow: 1;
  flex-basis: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-basis: calc(25% - 16px);
  }

  > .card-panel__left {
    flex-basis: 50%;
    padding: 24px 0 24px 24px;
    box-sizing: border-box;

    > h3 {
      font-size: ${({ theme }) => theme.fontSizes.base};
      font-weight: 600;
      line-height: ${({ theme }) => theme.lineHeights.base};
      color: ${({ theme }) => theme.primaryText};
    }
  }

  > .card-panel__right {
    background-image: url(${bubbles});
    flex-basis: 50%;
    background-position: left;
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      min-width: 70px;
    }
  }
`;

export default StyledCardPanel;
